import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "sonner";
import { updateStudentRegistration } from "../../api/etudiants";

type Props = {
  show: boolean;
  onClose: () => void;
  onSaved?: () => void;
  registration?: any; // objet d'inscription courant
  studentParcours?: any[]; // parcours liés à l'étudiant [{ id, Parcour: { title, Cycle: { label } } }]
};

const EditParcoursModal: React.FC<Props> = ({
  show,
  onClose,
  onSaved,
  registration,
  studentParcours = [],
}) => {
  const [selectedParcours, setSelectedParcours] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (registration) {
      setSelectedParcours(registration.id_parcoursStudent ?? null);
    }
  }, [registration]);

  const handleSave = async () => {
    if (!registration) return toast.error("Aucune inscription sélectionnée");
    if (!selectedParcours) return toast.error("Veuillez sélectionner un parcours");
    setSaving(true);
    try {
      await updateStudentRegistration(registration.id, {
        id_parcoursStudent: selectedParcours,
      });
      toast.success("Parcours mis à jour avec succès");
      onSaved && onSaved();
      onClose();
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message || err?.message || "Erreur lors de la mise à jour",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <div className="modal-header">
        <h4 className="modal-title">Modifier le parcours d'inscription</h4>
        <button
          type="button"
          className="btn-close custom-btn-close"
          aria-label="Close"
          onClick={onClose}
        >
          <i className="ti ti-x" />
        </button>
      </div>
      <div className="modal-body">
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Parcours</Form.Label>
            <Form.Select
              value={selectedParcours ?? ""}
              onChange={(e) => setSelectedParcours(e.target.value || null)}
            >
              <option value="">Sélectionner un parcours</option>
              {studentParcours.map((p: any) => (
                <option key={p.id} value={p.id}>
                  {p.Parcour?.Cycle?.label
                    ? `${p.Parcour.Cycle.label} - ${p.Parcour.title}`
                    : p.Parcour?.title}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Form>
      </div>
      <div className="modal-footer gap-2">
        <Button variant="danger" onClick={onClose} disabled={saving}>
          Annuler
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={
            saving ||
            !selectedParcours ||
            selectedParcours === registration?.id_parcoursStudent
          }
        >
          {saving ? "Enregistrement..." : "Enregistrer"}
        </Button>
      </div>
    </Modal>
  );
};

export default EditParcoursModal;